import metadata from '@legal/agreements.json';
import eulaText from '@legal/eula.md?raw';
import baaText from '@legal/baa.md?raw';

import { appRoutes } from '@/constants/routes';

export const agreements = {
  eula: {
    title: 'End User License Agreement',
    label: 'EULA',
    effective: formatEffective(metadata.eula.effectiveDate),
    text: eulaText,
    route: appRoutes.agreementEula,
  },
  baa: {
    title: 'Business Associate Agreement',
    label: 'BAA',
    effective: formatEffective(metadata.baa.effectiveDate),
    text: baaText,
    route: appRoutes.agreementBaa,
  },
};

// Dates in the metadata are calendar days, so they are formatted in UTC to stay on that day everywhere.
function formatEffective(isoDate: string): string {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) throw new Error(`Invalid effective date in legal/agreements.json: ${isoDate}`);
  return `Effective ${new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date)}`;
}
